import React, { useEffect, useState } from 'react'
import '../spare/cu-spare.scss'
import NormalInput from '../../common/inputs/NormalInput'
import SelectInput from '../../common/inputs/SelectInput'
import { productTypes } from '../../../assets/javascript/const-data'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'
import MultiSelect from '../../common/inputs/MultiSelect'

const CUServiceWork = ({ currentData, setModal, setData, isEdit }) => {
  const [form, setForm] = useState({})
  

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleMultiSelect = (name, e) => {
    setForm({
      ...form,
      [name]: e?.map((v) => v.value)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = {
      work_name: form?.work_name || null,
      applicable_for: form?.applicable_for || [],
      package_pricing: [],
      selling_rate: Number(form?.selling_rate) || 0,
      purchase_cost: Number(form?.purchase_cost) || 0,
      call_rate: Number(form?.call_rate) || 0,
      refill_included: form?.refill_included === 'Yes' ? true : false,
      reinstallation_included: form?.reinstallation_included === 'Yes' ? true : false
    }

    if (isEdit) {
      customerAxios.put(`/production-v0/service-work/${currentData?.work_id}/info`, body).then(() => {
        setModal({ status: false })
        toast.success(`Service Work Updated! \n Refresh and Reopen the work to View`)

      }).catch((error) => {
        toast.error(error.message)
      })
    } else {
      // Create new associate

      body.pricing_source = 'SERVICE_WORK'

      customerAxios.post(`/production-v0/service-work`, body).then(() => {
        setModal({ status: false })
        toast.success(`Service Work Created! \n Refresh and Reopen the work to View`)

      }).catch((error) => {
        toast.error(error.message)
      })
    }
  }

  useEffect(() => {
    if (isEdit) {
      const temp = {
        work_name: currentData?.work_name,
        applicable_for: currentData?.applicable_for || [],
        selling_rate: currentData?.selling_rate || 0,
        purchase_cost: currentData?.purchase_cost || 0,
        call_rate: currentData?.call_rate || 0,
        refill_included: currentData?.refill_included ? 'Yes' : 'No',
        reinstallation_included: currentData?.reinstallation_included ? "Yes" : "No"
      }

      setForm(temp)
    }

    // eslint-disable-next-line
  }, [currentData])


  return (
    <div className="cu-spare-sub-div">
      <form action="" onSubmit={handleSubmit}>
        <div className="input-group-div">
          <NormalInput label='Work Name *' name='work_name' value={form?.work_name} onChangeFun={handleChange} />
          <MultiSelect label='Applicable For *' name='applicable_for' values={productTypes?.map((p) => ({ label: p, value: p }))}
            onChangeFun={(e) => handleMultiSelect('applicable_for', e)} selectedValue={currentData?.applicable_for?.map((p) => ({ label: p, value: p }))}
            required />
          <NormalInput label='Selling Rate (SR) *' type={'number'} name='selling_rate' value={form?.selling_rate} onChangeFun={handleChange} min={0} />
          <NormalInput label='Purchase Cost (PC) *' type={'number'} name='purchase_cost' value={form?.purchase_cost} onChangeFun={handleChange} min={0} />
          <NormalInput label='Call Rate *' type={'number'} name='call_rate' value={form?.call_rate} onChangeFun={handleChange} min={0} />

          <SelectInput label='Refill Included *' name='refill_included' values={['Yes', "No"]?.map((u) => ({ option: u, value: u, selected: u === form?.refill_included }))} onChangeFun={handleChange}
            firstOption={{ option: 'Choose...', value: '' }} />
          <SelectInput label='Reinstallation Included *' name='reinstallation_included' values={['Yes', "No"]?.map((u) => ({ option: u, value: u, selected: u === form?.reinstallation_included }))}
            onChangeFun={handleChange} firstOption={{ option: 'Choose...', value: '' }} />
        </div>

        <button>Submit</button>
      </form>
    </div>
  )
}

export default CUServiceWork